import myTraderaItemsSelector from './items';
import { logger } from 'packages';
import {
    findKeysByPurchaseOrderId,
    findKeysByTransactionId
} from '../../helpers/commands-helper.js';

const updateStateAndLabels = (item, listViewType) => {
    if (listViewType === undefined) {
        try {
            throw 'updateStateAndLabels: listViewType === undefined, ' + item;
        } catch (e) {
            logger(e);
        }
    }
    return myTraderaItemsSelector.getPurchasedItem(item, listViewType);
};

const setPaidState = (flag, listViewType) => items => key => {
    let item = items[key];
    if (!item) {
        try {
            throw `setPaidState failed. tried to find key ${key} in ${JSON.stringify(
                items
            )}`;
        } catch (e) {
            logger(e);
        }
    }
    item.transaction.buyerState.paid = flag;
    return updateStateAndLabels(item, listViewType);
};

const setTransactionHiddenState = (flag, listViewType) => items => key => {
    let item = items[key];
    if (!item) {
        try {
            throw `setTransactionHiddenState failed. tried to find key ${key} in ${JSON.stringify(
                items
            )}`;
        } catch (err) {
            logger(err);
        }
        return [];
    }

    item.transaction.buyerState.hidden = flag;
    return updateStateAndLabels(item, listViewType);
};

export const markAsPaidByBuyerReducer = (state, action) => {
    let stateItems = { ...state.itemsByID };
    const updateChangedItems = setPaidState(
        true,
        action.payload.listViewType
    )(stateItems);
    const findUpdatedKeysByPurchaseOrderId = findKeysByPurchaseOrderId(
        stateItems
    );
    const updatedItems = action.payload.ids
        .map(findUpdatedKeysByPurchaseOrderId)
        .map(updateChangedItems);
    updatedItems.forEach(updatedItem => {
        stateItems[updatedItem.key] = updatedItem;
    });

    return stateItems;
};

export const unmarkAsPaidByBuyerReducer = (state, action) => {
    let stateItems = { ...state.itemsByID };
    const updateChangedItems = setPaidState(
        false,
        action.payload.listViewType
    )(stateItems);
    const findUpdatedKeysByPurchaseOrderId = findKeysByPurchaseOrderId(
        stateItems
    );
    const updatedItems = action.payload.ids
        .map(findUpdatedKeysByPurchaseOrderId)
        .map(updateChangedItems);

    updatedItems.forEach(updatedItem => {
        stateItems[updatedItem.key] = updatedItem;
    });

    return stateItems;
};

export const markTransactionAsHiddenByBuyerReducer = (state, action) => {
    let updatedItems = { ...state.itemsByID };

    const updateChangedItems = setTransactionHiddenState(
        true,
        action.payload.listViewType
    )(updatedItems);
    const findUpdatedKeysByTransactionId = findKeysByTransactionId(
        updatedItems
    );
    action.payload.ids
        .map(findUpdatedKeysByTransactionId)
        .map(updateChangedItems);
    return updatedItems;
};

export const markTransactionAsShownByBuyerReducer = (state, action) => {
    let updatedItems = { ...state.itemsByID };

    const updateChangedItems = setTransactionHiddenState(
        false,
        action.payload.listViewType
    )(updatedItems);
    const findUpdatedKeysByTransactionId = findKeysByTransactionId(
        updatedItems
    );
    action.payload.ids
        .map(findUpdatedKeysByTransactionId)
        .map(updateChangedItems);
    return updatedItems;
};
